module.exports = __webpack_public_path__ + "static/img/slogan.fd990e07.png";